import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Treatments.css";
import logo from '../images/6_Ayur copy.webp'
import serviceImg from "../images/post_natal.webp";
import { MdOutlineMail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import AyurvedaFooter from "../AyurvedaFooter/AyurvedaFooter";
import ScrollToTop from '../ScrollToTop'
import { MdCall } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import WhatsAppButton from "../WhatsAppButton";
import { FaLocationArrow } from "react-icons/fa6";
import ScrollTop from "../ScrollTop";
import { useState } from "react";
import { FaHandPointDown } from "react-icons/fa";
import { FaHandPointUp } from "react-icons/fa";
import Package from "../Packages/Package";
import { Helmet } from 'react-helmet-async';
export default function PostNatalCare() {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);


  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");
  return (
    <>
    <Helmet>
  <title>
    Postnatal Care Treatment in Kerala
  </title>

  <meta
    name="description"
    content="Experience authentic Ayurvedic postnatal care at Ayurmoksha Ayurveda clinic in Kozhikode, Kerala. Our postnatal treatment program supports recovery after childbirth, enhances strength, promotes healthy lactation, balances hormones, and restores physical and mental well-being through traditional Ayurvedic therapies."
  />

  <meta
    name="keywords"
    content="Postnatal Care Ayurveda Kozhikode kerala,Ayurmoksha Postnatal Care, Ayurveda clinic Kozhikode, Post Delivery Care Ayurveda, Post Pregnancy Ayurvedic Treatment Kerala, Best Postnatal Care Kerala, Traditional Ayurveda Postnatal Care"
  />

  <meta name="robots" content="index, follow" />

  <link rel="canonical" href="https://ayurmoksha.in/postnatal" />

  {/* Open Graph Meta */}
  <meta property="og:locale" content="en_IN" />
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Postnatal Ayurvedic Care | Ayurmoksha Ayurveda clinic Kozhikode Kerala"
  />
  <meta
    property="og:description"
    content="Ayurmoksha Ayurveda clinic in Kozhikode Kerala offers specialized postnatal Ayurvedic care to support maternal recovery, rejuvenation, and long-term wellness using classical Ayurvedic therapies."
  />
  <meta
    property="og:url"
    content="https://ayurmoksha.in/postnatal"
  />
  <meta
    property="og:site_name"
    content="Ayurmoksha Ayurveda clinic"
  />
  <meta
    property="og:image"
    content="https://ayurmoksha.in/logo.webp"
  />
  <meta
    property="og:image:alt"
    content="Postnatal Care at Ayurmoksha Ayurveda clinic in Kozhikode Kerala"
  />

  <meta name="author" content="Ayurmoksha Ayurveda clinic" />
</Helmet>

    <ScrollTop/>
     {/* main section */}
      <section className="container-fluid about-main-section">
      {/* Overlay */}
      <div className="about-main-overlay"></div>

      {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-dark about-navbar">
        <div className="container">

          {/* Logo */}
           <a className="navbar-brand" href="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
          </a>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#aboutNavbar"
            aria-controls="aboutNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="aboutNavbar">

             <ul className="navbar-nav align-items-lg-center gap-lg-3 text-center">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink>
              </li>

              <li className="nav-item">
              
                <NavLink  className="nav_Active" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink>
              </li>

              <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

                <li className="nav-item">
                  <NavLink className="nav_Active" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>contact</b></NavLink>
              </li>
             
            </ul>
          </div>

        </div>
        <div className="d-none d-lg-flex align-items-center gap-3 ms-auto">
<span className="phone-inline">
  <MdCall /><b>+91 7736 111 482</b> 
</span>


  <a
    href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20know%20more%20about%20your%20treatments"
    target="_blank"
    rel="noopener noreferrer"
    className="messenger-btn"
    style={{ backgroundColor: "#006400", textDecoration: "none" }}
  >
    WhatsApp
  </a>
</div>

      </nav>

      {/* Center Content */}
      <div className="about-main-content">
        <h1 className="head-font" style={{color:'#f7f0d3'}}>Postnatal Care</h1>
        <p>
          <span className="para-font">Home</span>
          <span className="mx-2">»</span>
          <span className="para-font">Postnatal Care</span>
        </p>
      </div>
    </section>
    {/* =========== */}
    <section className="service-detail-wrapper">
      <div className="container">
        <div className="row">

          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-5 mb-lg-0">
            <div className="service-image">
              <img src={serviceImg} alt="Abhyanga Therapy"  className="img-fluid" style={{height:'500px'}}/>
            </div>

            <h2 className="service-title head-font">Postnatal Care</h2>

            <p className="para-font justify-text" style={{fontSize:'20px',color:'#555'}}> <b><i>A complete mother and baby care rejuvenation program based on authentic Ayurveda.</i></b></p>
            <p className="service-desc para-font justify-text">
              Childbirth brings joy, but it also places immense strain on a mother’s body and mind.
              According to Ayurveda, the postnatal phase is dominated by Vata imbalance leading to pain, weakness, fatigue, disturbed sleep, and delayed recovery.<br/>
              Our Postnatal Ayurvedic Care Package helps restore balance, rebuild strength, support healthy lactation, and ensure complete rejuvenation naturally and safely. As part of the program, some medicines are prepared in-house using carefully handpicked herbs to ensure safe and effective postnatal care.

            </p>

            <h5 className="service-subtitle head-font">Benefits of the package</h5>

            <div className="row service-benefits">
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Reduces postnatal body pain & stiffness</li>
                  <li>✔ Improves muscle tone & circulation</li>
                  <li>✔ Supports uterine recovery</li>
                   <li>✔ Enhances lactation & hormonal balance</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="para-font">
                  <li>✔ Improves sleep & mental calmness</li>
                  <li>✔ Restores skin glow & overall vitality</li>
                  <li>✔ Improves digestion & Metabolism</li>
                   <li>✔ Promote tissue nourishment </li>
                </ul>
              </div>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="service-sidebar">

              <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Our Services</h5>
                    <ul className="para-font">
                      <li><FaLocationArrow />&nbsp;&nbsp;Inpatient Services</li>
                       <li><FaLocationArrow />&nbsp;&nbsp;Home Care Services </li>
                      <li><FaLocationArrow />&nbsp;&nbsp;Day Care Patient Services</li>
                       {/* <li><FaLocationArrow />&nbsp;&nbsp;Life Style Guidance & Yoga</li>
                       <li><FaLocationArrow />&nbsp;&nbsp;Soundarya Kapla</li> */}
                     </ul>
              </div>

             <div className="sidebar-card">
  <h5 className="head-font" style={{ color: "wheat" }}>
    Treatment overview
  </h5>

  <div className={`overview-wrapper ${showMore ? "expanded" : ""}`}>
    <ul className="para-font">
      <li style={{color:'wheat'}}>&nbsp;&nbsp;Body Therapies</li>
      <li><FaLocationArrow /> Abhyangam</li>
      <li><FaLocationArrow /> Podi Kizhi</li>
      <li><FaLocationArrow /> Ila Kizhi</li>
      <li><FaLocationArrow /> Naranga Kizhi</li>
      <li><FaLocationArrow /> Navara Kizhi</li>
      <li><FaLocationArrow /> Nadi Swedam</li>
      <li><FaLocationArrow /> Kashayadhara</li>
      <li><FaLocationArrow /> Abdominal Binding</li><br/>

      <li style={{color:'wheat'}}>&nbsp;&nbsp;Head, Face & Skin Care</li>
      <li><FaLocationArrow /> Head Massage</li>
      <li><FaLocationArrow /> Hair Pack</li>
      <li><FaLocationArrow /> Face Massage</li>
      <li><FaLocationArrow /> Face Pack</li>
      <li><FaLocationArrow /> Facial</li>
      <li><FaLocationArrow /> Body Pack</li>
      <li><FaLocationArrow /> Pedicure</li>
      <li><FaLocationArrow /> Manicure</li>
      <li><FaLocationArrow /> Herbal Foot Pack</li>
      <li><FaLocationArrow /> Navara Theppu</li>

      <li style={{color:'wheat'}}>&nbsp;&nbsp;Detox Therapies</li>
      <li><FaLocationArrow /> Vethukuli</li>
      <li><FaLocationArrow /> Keshadhoomam</li>

      <li style={{color:'wheat'}}>&nbsp;&nbsp;Sense Organ Care</li>
      <li><FaLocationArrow /> Anjanam</li>
      <li><FaLocationArrow /> Nasadhoomam</li>
      <li><FaLocationArrow /> Shirodhara</li>
      <li><FaLocationArrow /> Thalam</li>
    </ul>
  </div>

  <button
    className="read-more-btn" style={{color:'wheat'}}
    onClick={() => setShowMore(!showMore)}
  >
   {showMore ? (
    <>Read Less <FaHandPointUp /></>
  ) : (
    <>Read More <FaHandPointDown /></>
  )}
  </button>
</div>
    <div className="sidebar-card">
                <h5 className="head-font" style={{color:'wheat'}}>Our Contact</h5>
                  <ul className="para-font">
                         <li><FaPhone/> +91 7736 111 482</li>
                        <li><MdOutlineMail/> ayurmokshacalicut@gmail.com</li>
                         <li><FaLocationDot/>&nbsp;Ruby Road, Karuvanthuruthy, Feroke, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Kozhikode,Kerala 673631</li>
                      </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Package/>
    <AyurvedaFooter/>
     <ScrollToTop/>
      <WhatsAppButton />
    </>
  );
}
